export default {
    "header": {"Flights": "Voli", "Booking Status": "Status Prenotazione", "Contact": "Contatti"},
    "general": {
        "Back": "Indietro",
        "Close": "Chiudi",
        "Cancel": "Annulla",
        "Confirm": "Conferma",
        "E-Mail": "E-Mail",
        "Example E-Mail": "mario.rossi@gmail.com",
        "Phone": "Telefono",
        "Error request": "Si è verificato un errore durante la richiesta. Si prega di riprovare",
        "First Name": "Nome",
        "Last Name": "Cognome",
        "Example Last Name": "Esempio Rossi",
        "Example First Name": "Esempio Mario",
        "Mr": "Sig.",
        "Miss": "Sig.na",
        "Mrs": "Sig.ra",
        "Title": "Titolo",
        "Country": "Paese",
        "Date of Birth": "Data di nascita",
        "Example Address": "Via Roma 123",
        "Address": "Indirizzo",
        "City": "Città",
        "Example City": "Milano",
        "Zip Code": "Codice postale",
        "Example Zip Code": "02100",
        "Company Name": "Nome della società",
        "Example Company Name": "ACME SRL",
        "Voucher": "Buono",
        "Example Voucher": "CODICE ESEMPIO",
        "Are you sure?": "Sei sicuro?",
        "Message": "Messaggio",
        "Market": "Italia",
        "from Market": "dall'Italia",
        "to Market": "in Italia",
        "Open": "Apri",
        "Edit": "Modifica",
        "Delete": "Cancella",
        "Send": "Invia",
        "Update": "Aggiorna",
        "Name": "Nome",
        "Photo credits": "Crediti foto",
        "Continue": "Continua",
        "and": "e",
        "Password": "Password",
        "Password Confirm": "Conferma Password",
        "Example Booking code": "Per esempio 1A2B3C4D5E6F7G8",
        "Product": "Prodotto",
        "Gender": "Genere",
        "Male": "Uomo",
        "Female": "Donna",
        "Company VAT": "Partita Iva",
        "Example Company VAT": "IT12345678901",
        "Booking Code": "Codice Prenotazione",
        "Verify": "Verifica",
        "Your Name": "Tuo Nome",
        "Your E-Mail": "Tua E-Mail",
        "Your Phone": "Tuo Telefono",
        "Your Message": "Messaggio",
        "Your Booking Code": "Tua Prenotazione"
    },
    "date": {
        "January": "Gennaio",
        "February": "Febbraio",
        "March": "Marzo",
        "April": "Aprile",
        "May": "Maggio",
        "June": "Giugno",
        "July": "Luglio",
        "August": "Agosto",
        "September": "Settembre",
        "October": "Ottobre",
        "November": "Novembre",
        "December": "Dicembre",
        "Day": "Giorno",
        "Month": "Mese",
        "Year": "Anno"
    },
    "search-flight": {
        "Book Now": "Continua",
        "Marketing Cheapest": "Più economico",
        "Marketing Quickest": "Più veloce",
        "Marketing Best": "Migliore",
        "Departure date cant be empty": "Seleziona una data di partenza",
        "Load other results": "Carica altri risultati",
        "Select a departure": "Seleziona un aeroporto o città di partenza",
        "roundtrip": "Andata e ritorno",
        "oneway": "Solo andata",
        "From": "Da",
        "To": "A",
        "From airport": "Partenza",
        "To airport": "Destinazione",
        "Airport or City": "Aeroporto o città",
        "Passengers": "Passeggeri",
        "Adults": "Adulti",
        "Adults Information": "Più di 12 anni",
        "Children": "Bambini",
        "Children Information": "2 - 12 anni",
        "Infants": "Neonati",
        "Invert Departure with Destination": "Inverti la partenza con la destinazione",
        "Infants Information": "Meno di 2 anni",
        "Passengers Adults": "{adults} adulto|{adults} adulti",
        "Passengers Total": "{passengers} passeggero | {passengers} passeggeri",
        "Travelclass economy": "Economica",
        "Travelclass premium": "Premium",
        "Travelclass first": "Prima Classe",
        "Travelclass business": "Business",
        "Departure": "Partenza",
        "Return": "Ritorno",
        "Departure Date": "Partenza",
        "Return Date": "Ritorno",
        "Search": "Cerca",
        "Autocomplete No Result": "Nessun aeroporto/città trovato",
        "Travelclass": "Classe di viaggio",
        "Select a travelclass for your search": "Selezionare una classe di viaggio per la ricerca",
        "Confirm": "Conferma",
        "Create price alert": "Crea un avviso di prezzo",
        "Outward": "Andata",
        "Details": "Dettagli",
        "price per passenger": "prezzo per passeggero",
        "Continue": "Continua",
        "Filter Stops": "Scali",
        "Filters Any Stop": "Qualsiasi scalo",
        "Filters 1 Stop": "1 scalo",
        "Filters 2 Stops": "2 scali",
        "Filters 3 Stops": "3 scali",
        "Filters Direct Flight": "Volo diretto",
        "Filter Duration": "Durata",
        "Filter Stop duration": "Durata dello scalo",
        "Filter Price Range": "Intervallo di prezzo",
        "Filter Departure": "Partenza",
        "Filter Return": "Ritorno",
        "Filter Time Departure": "Ora di partenza",
        "Filter Time Arrival": "Ora di arrivo",
        "Filter Carriers": "Compagnie aeree",
        "Filter Results": "Filtra i risultati",
        "Filters": "Filtri",
        "Direct": "Diretto",
        "1 Stop": "1 scalo",
        "2 Stops": "2 scali",
        "3 Stops": "3 scali",
        "Duration just h": "{hour}h",
        "Duration just m": "{min}m",
        "Duration h and m": "{hour}h {min}m",
        "Some suggestions based on your position": "Alcuni suggerimenti in base alla tua posizione",
        "Digit 3 characters and select from the list": "Digitare 3 caratteri e selezionare dall'elenco",
        "Sorry no airports or city found": "Non sono stati trovati aeroporti o città",
        "Alert Update about this route": "Ricevi aggiornamenti su questa ricerca",
        "Activate an alert": "Attiva un avviso",
        "Send me a notification": "Inviami una notifica",
        "Everyday": "Ogni giorno",
        "Every two days": "Ogni due giorni",
        "Every three days": "Ogni tre giorni",
        "Every five days": "Ogni cinque giorni",
        "Every week": "Ogni settimana",
        "Every two weeks": "Ogni due settimane",
        "Details Flight": "Dettagli Volo",
        "Details Flights": "Dettagli Voli",
        "Order by Best": "Ordina per migliore",
        "Order by Price": "Ordine per prezzo",
        "Order by Duration": "Ordine per durata",
        "Different airport": "L'arrivo sarà a {arrival} e la ripartenza da {departure}.",
        "Stop segment just h": "Scalo di {hour}h",
        "Stop segment just m": "Scalo di {min}m",
        "Stop segment h and m": "Scalo di {hour}h {min}m",
        "No Results First Row": "oh no...",
        "No Results Second Row": "sembra che nessun volo",
        "No Results Third Row": "è disponibile",
        "No Results Filters First Row": "oh no...",
        "No Results Filters Second Row": "sembra che non ci sia nessun volo",
        "No Results Filters Third Row": "è disponibile",
        "Alternative next_departure_day": "Partenza il giorno successivo",
        "Alternative next_return_day": "Ritorno il giorno successivo",
        "Alternative different_day": "Giorno diverso",
        "Alternative different_days": "Giorni diversi",
        "Alternative closer_departure": "Partenza da un aeroporto vicino",
        "Alternative closer_destination": "Arrivo all'aeroporto vicino",
        "Alternative different_route": "Aeroporti diversi",
        "Segment 1": "Volo diretto",
        "Segment 2": "1 scalo",
        "Segment 3": "2 scali",
        "Segment 4": "3 scali",
        "All flights": "Tutti i voli",
        "Combination with multiple companies": "Più compagnie",
        "Remove some filter to have more results": "Rimuovi qualche filtro per avere più risultati",
        "No Results Filter First Row": "Nessun risultato presente con",
        "No Results Filter Second Row": "filtri attuali impostati",
        "No Results Filter Third Row": "Rimuovere alcuni filtri o cambiare la data del viaggio",
        "Plus 1 day": "+1 g",
        "Plus X days": "+{days} g",
        "Departure date": "Data di partenza",
        "Return date": "Data di ritorno",
        "Edit": "Modifica",
        "Filter results": "Filtra i risultati",
        "Back on top": "Torna in cima",
        "Best solution": "Miglior Valore",
        "Cheapest": "Più economico",
        "Fastest": "Più veloce",
        "Order by": "Ordina per",
        "Price Alert": "Avviso prezzo",
        "Price Calendar": "Calendario dei prezzi",
        "Calendar": "Calendario",
        "Prices starting at price": "Prezzi a partire da {price}",
        "Order by Departure Hour": "Ordina per ora di partenza",
        "Order by Arrival Hour": "Ordina per ora di arrivo",
        "Departure Hour": "Ora di partenza",
        "Arrival Hour": "Ora di arrivo",
        "Long stop info": "Scalo lungo",
        "Short stop info": "Scalo rapido",
        "Deactivate alert": "Disattiva avviso",
        "Deactivate Alert about this route": "Sei sicuro di voler disattivare gli avvisi per questa ricerca?",
        "Alert is now deactivated": "Gli avvisi sono ora disattivati",
        "Overnight stops": "Scalo notturno",
        "Destinations from city": "Voli da {departure}",
        "Prices indicated map": "I prezzi sono per passeggero e indicativi",
        "Prices approximated": "I prezzi mostrati sono per passeggeri. Alcuni prezzi sono approssimati e verranno ricalcolati dopo aver selezionato la destinazione.",
        "Popularity": "Popolarità",
        "Order by Popularity": "Ordina per popolarità",
        "Further": "Lontananza",
        "Closest": "Vicinanza",
        "Order by Closest": "Ordina per vicinanza",
        "Order by Further": "Ordina per lontananza",
        "Departure and destination same": "La partenza e l'arrivo non possono coincidere",
        "Updated X": "Aggiornato {when}",
        "Departure Airports": "Aeroporti di partenza",
        "Destination Airports": "Aeroporti di arrivo",
        "You can try to choose an alternative search": "È possibile scegliere una ricerca alternativa",
        "Filter Times": "Orari",
        "Filter Airports": "Aeroporti",
        "Select all": "Tutte",
        "Deselect all": "Deseleziona",
        "Airline Only": "Solo",
        "Next Day": "Giorno Successivo",
        "Previous Day": "Giorno Precedente",
        "Stop segment just h in airport": "Scalo di {hour}h a {airport}",
        "Stop segment just m in airport": "Scalo di {min}m a {airport}",
        "Stop segment h and m in airport": "Scalo di {hour}h {min}m a {airport}",
        "Stay X nights": "{nights} notte a {destination}|{nights} notti a {destination}",
        "Arrival in X": "Arrivo a {airport}",
        "price per passenger without commission": "prezzo per passeggero + {commission} tassa di servizio",
        "final price": "Prezzo finale",
        "final price without commission amount": "Tariffa per un passeggero + {commission} tassa di servizio | Tariffa per {n_pax} passeggeri + {commission} tassa di servizio",
        "final price without commission": "Tariffa per un passeggero | Tariffa per {n_pax} passeggeri",
        "Anywhere": "Ovunque",
        "Show results containing this flight": "Mostra risultati che contengono questo volo",
        "Number results": "{results} voli",
        "Passengers & Class": "Passeggeri e Classe",
        "Outbound Flights": "Voli Andata",
        "Inbound Flights": "Voli Ritorno",
        "Duration": "Durata",
        "Order": "Ordina",
        "Loading results": "Cerchiamo la disponibilità su oltre 400 compagnie aeree"
    },
    "range": {"From Minutes To Minutes": "Da {0} a {1}", "From Time To Time": "Da {0} a {1}", "From": "Da", "To": "a"},
    "filter": {"departure": "Partenza", "return": "Ritorno"},
    "duration": {
        "just h": "{hour}h",
        "h and m": "{hour}h {min}m",
        "just m": "{min}m",
        "Just h": "{hour}h",
        "Just m": "{min}m"
    },
    "features": {
        "Best price guaranteed": "Miglior prezzo garantito",
        "Exclusive routes": "Rotte esclusive",
        "Best support": "Miglior supporto",
        "Clear Prices": "Prezzi Chiari",
        "Clear Prices description": "Fin dalla prima pagina è possibile vedere il prezzo reale del volo, senza trucchi.",
        "Exclusive routes description": "Combiniamo diverse compagnie aeree e rotte per avere più soluzioni e prezzi più bassi.",
        "Best support description": "Rispondiamo al telefono, rispondiamo alle e-mail, abbiamo un'ampia sezione con tutte le informazioni.",
        "Security": "Sicurezza",
        "Security description": "Sito web protetto con le migliori tecnologie e sicuro da usare.",
        "Exclusive Combinations": "Combinazioni esclusive",
        "Exclusive Combinations description": "Tutte le compagnie aeree, tutte le tariffe, combinazioni esclusive realizzate da Any Flight"
    },
    "alert": {
        "Receive alert": "Ricevi un avviso",
        "Daily": "Giornaliero",
        "Weekly": "Settimanale",
        "Every Two Weeks": "Ogni due settimane",
        "Alert is now active": "La richiesta è andata a buon fine. Ora l'avviso è attivo."
    },
    "booking": {
        "Booking": "Prenota",
        "This page is 100% safe": "Questa pagina è sicura al 100%",
        "Card holder": "Titolare carta",
        "Example Card holder": "Esempio Mario Rossi",
        "Secure": "Safe page",
        "Safe transmission data": "I tuoi dati personali sono protetti da una trasmissione sicura e da un'archiviazione criptata.",
        "Cvv": "Codice di sicurezza",
        "Expiration": "Data di scadenza",
        "You will be redirected to Coinbase page to complete the payment": "Per completare il tuo acquisto con criptovaluta, verrai reindirizzato alla piattaforma di pagamento Coinbase dove potrai scegliere tra diverse criptovalute sicure e affidabili.",
        "Info CVV": "Il CVV/CVC2 di solito si trova sul retro della carta, è composto da 3 numeri. Nell'esempio 123.",
        "Info Expiration": "La data di scadenza di solito si trova sul fronte della carta. È composta da mese e anno. Nell'esempio 10/33.",
        "Next step": "Prossimo: {step}",
        "Taxes and fees included": "Tasse e imposte incluse",
        "Rush Message": "The more you wait, the higher the fare! Book it now and save on the price.",
        "Booking Expired": "Prenotazione scaduta",
        "Booking is Expiring": "La prenotazione sta scadendo",
        "Booking Expired Message": "Siamo spiacenti ma il tempo per completare la prenotazione è scaduto e dobbiamo riconvalidare la ricerca.",
        "Booking Is Expiring Message": "Il tempo per completare la prenotazione sta per scadere. Completa quanto prima la prenotazione.",
        "Remaining time": "<b>Tempo restante:</b> {time}",
        "kg": "kg.",
        "Complete the form to book": "Completa il form e prenota il tuo volo!",
        "Title non refundable": "Biglietto non rimborsabile",
        "Title refundable": "Biglietto parzialmente rimborsabile",
        "Debit or Credit Card": "Carta di Credito o Debito",
        "Flight conditions": "Condizioni di volo",
        "Not selected": "Non selezionato",
        "No priority boarding": "Nessun imbarco prioritario",
        "Priority boarding": "Imbarco prioritario",
        "Cabin luggage": "Bagaglio in cabina",
        "We are checking the price for the chosen trip": "Stiamo verificando il prezzo del viaggio scelto",
        "We are working out the final quote for your trip": "Stiamo elaborando il preventivo finale per il vostro viaggio. A breve vi verrà chiesto di inserire i dati relativi ai passeggeri e potrete scegliere i servizi aggiuntivi, se disponibili.",
        "Flight from X to Y": "Volo da {departure} a {destination}",
        "Marketing Best Price": "Hai trovato la <b>tariffa migliore per volare a {destination}</b>",
        "Marketing Best Duration": "Hai trovato <b>il volo più veloce per {destination}</b>",
        "Marketing Best Price 10": "Hai trovato uno dei <b>viaggi più economici per {destination}</b>",
        "Marketing Best Price 20": "Hai trovato un <b>viaggio per {destination} con un buon prezzo</b>",
        "Marketing Best Duration 10": "Hai trovato uno dei <b>viaggi più veloci per {destination}</b>",
        "Marketing Best Duration 20": "Hai trovato un <b>viaggio per {destination} con una buona durata</b>",
        "Marketing 1 Interested": "Una persona è interessata a questo viaggio",
        "Marketing More Interested": "<b>{count} persone</b> sono interessate a questo viaggio",
        "Contact Details": "Dati di contatto",
        "Lead Passenger": "Passeggero principale",
        "X Passenger": "Passeggero {count}",
        "At least one adult is required": "E' richiesto almeno un adulto",
        "adult": "Adulto",
        "child": "Bambino",
        "infant": "Neonato",
        "Title": "Titolo",
        "Hold Luggage": "Bagaglio da stiva",
        "Hold Luggage section": "Bagaglio da stiva",
        "Hand Luggage": "Bagaglio a mano",
        "Hand Luggage section": "Bagaglio a mano",
        "Select option luggage": "Selezionare la preferenza per il bagaglio da stiva:",
        "Add Passenger": "Aggiungi passeggero",
        "Continue": "Continua",
        "Update type customer to adult": "Abbiamo aggiornato il tipo di passeggero ad adulto",
        "Update type customer to child": "Abbiamo aggiornato il tipo di passeggero a bambino",
        "Update type customer to infant": "Abbiamo aggiornato il tipo di passeggero a neonato",
        "Error too many infants": "Non è possibile avere solo neonati e adulti in una prenotazione.",
        "Error too many passengers": "Non è possibile avere più di 9 passeggeri in una prenotazione.",
        "Error at least a 16 is required": "È richiesto almeno un passeggero di 16 anni.",
        "Additional services": "Servizi aggiuntivi",
        "Automatic Check-In": "Check&Go",
        "Automatic Check-In Info": "Ti invieremo la carta d'imbarco via e-mail. Così semplice! Senza problemi e sempre in tempo per il tuo volo.",
        "Travel Insurance": "Assicurazione di viaggio",
        "Luggage Insurance": "Assicurazione bagagli",
        "Disruption Protection": "Protezione volo",
        "Disruption Protection Info": "In caso di disservizi causati dalla compagnia aerea, riceverete un risarcimento fino a 600 euro per passeggero.",
        "Provided by Name": "fornito da {name}",
        "Terms and conditions": "Termini e condizioni",
        "Passengers": "Passeggeri",
        "Summary and payment": "Riepilogo e pagamento",
        "Contacts": "Contatti",
        "Personal": "Persona Fisica",
        "Company": "Azienda",
        "Billing data": "Dati fatturazione",
        "Voucher code": "Codice voucher",
        "Credit Card": "Carta di credito",
        "Card number": "Numero della carta di pagamento",
        "Card Holder": "Titolare della carta",
        "We are processing the payment": "Stiamo elaborando il pagamento",
        "This operation will last just some seconds": "Questa operazione durerà solo pochi secondi",
        "Retry payment": "Riprova il pagamento",
        "An error occurred during the elaboration of your payment": "Si è verificato un errore durante l'elaborazione del pagamento:",
        "Order complete": "Ordine #{internal_code} completato",
        "Your order is now complete": "Il tuo ordine e' ora completo. Ti abbiamo inviato una E-Mail con la conferma del tuo ordine.",
        "Confirmation order": "Riceverai al più presto il biglietto con i dettagli per effettuare il check-in e le istruzioni di imbarco.",
        "adults": "Adulti",
        "Price details": "Dettagli del prezzo",
        "Includes commission": "Include la commissione",
        "Total": "Totale",
        "Price changed": "Il prezzo della prenotazione è stato modificato",
        "Aircompany increased price of reservation": "Purtroppo la compagnia aerea ha appena modificato il prezzo della vostra prenotazione.",
        "CVC": "CVC",
        "Old price": "Vecchio prezzo",
        "New price": "Nuovo prezzo",
        "Accept current price": "Accetta il prezzo attuale",
        "Or you can select an alternative": "Oppure puoi selezionare un'alternativa",
        "Show all results": "Mostra tutti i risultati",
        "No luggage": "Senza bagagli",
        "Boarding priority included": "Priorità d'imbarco inclusa",
        "Small luggage": "Bagaglio piccolo",
        "Luggage": "Bagaglio",
        "Free": "Gratuito",
        "Single Luggage": "1 bagaglio da stiva",
        "Multiple Luggage": "{count} bagagli da stiva",
        "Single Hand Luggage": "1 Bagaglio a mano",
        "Multiple Hand Luggage": "{count} Bagaglio a mano",
        "Single Priority boarding": "1 imbarco prioritario",
        "Multiple Priority boarding": "{count} imbarchi prioritari",
        "All information related to this passenger will be removed": "Tutte le informazioni relative a questo passeggero saranno rimosse.",
        "Add check-in": "Aggiungi il check-in automatico per {price} per passeggero",
        "No check-in": "Non ho bisogno del servizio Check&Go",
        "Add insurance per day": "Prezzo al giorno",
        "Add insurance": "{price} in totale",
        "Compensation of": "Risarcimento di {amount}",
        "Add per passenger": "Aggiungere per {price} per passeggero",
        "Flight Disruption": "Protezione contro i problemi del volo",
        "Flight Compensation": "Protezione volo",
        "Operated by": "Operato da {aircompany}",
        "Short stop": "Informazioni sullo scalo breve",
        "Long stop": "Info scalo lungo",
        "Small personal item": "Piccolo oggetto personale",
        "Show only some options": "Mostra solo alcune opzioni",
        "Show all options": "Mostra tutte le opzioni",
        "Payment": "Pagamenti",
        "Payment information": "I pagamenti sul nostro sito web sono protetti dalla più alta tecnologia SSL.",
        "Credit Card Visa/Mastercard": "Carta di credito Visa/Mastercard",
        "American Express": "American Express",
        "Pay using your credit or debit card Visa or Mastercard": "Pagamenti con carta di credito o di debito Visa o Mastercard",
        "Pay using your credit or debit card American Express": "Pagamenti con carta di credito o di debito American Express",
        "Pay using your credit or debit card": "Pagamenti con carta di credito o di debito Visa, Mastercard o American Express",
        "Cryptocurrencies": "Criptovaluta",
        "Pay using your Bitcoin, Bitcoin Cash, Dai, Dodge coin, Etherum or USD Coin wallet": "Paga utilizzando il portafoglio Bitcoin, Bitcoin Cash, Dai, Dodge coin, Etherum o USD Coin",
        "Terms & Conditions": "Termini e condizioni",
        "Small Luggage": "Bagaglio piccolo",
        "Priority": "Imbarco prioritario",
        "Just bought my ticket to city": "Ho appena comprato il mio biglietto per <u>#{city}</u>",
        "Just bought my ticket to city plain": "Ho appena acquistato il mio biglietto per #{city} #ninjatrip",
        "Share on Facebook": "Condividi su Facebook",
        "Share on Twitter": "Condividi su Twitter",
        "Download image": "Scarica l'immagine",
        "Share on Whatsapp": "Condividi su Whatsapp",
        "Fare rule": "Regole tariffarie",
        "No hold luggage": "Nessun bagaglio da stiva",
        "Warning": "Attenzione",
        "Exclusive solution made by Ninja Trip": "Questa soluzione esclusiva è realizzata da Ninja Trip. Include diversi voli di una o più compagnie aeree che normalmente non vengono venduti insieme.",
        "Exclusive solution made by Ninja Trip 2": "Questa soluzione esclusiva è realizzata da Ninja Trip.",
        "If you have hold luggage you need to collect it and recheck it": "Se hai un bagaglio da stiva, dovrai ritirarlo e ripresentarlo al check-in.",
        "In case of cancellation of one segment, there can’t be a refund on the remaining flights": "In caso di cancellazione di un segmento, non è previsto il rimborso dei voli rimanenti.",
        "In case of delay you may miss the connecting flight and the company may not reprotect you on another flight": "In caso di ritardo potresti perdere la coincidenza e la compagnia aerea non ti potrebbe riproteggere su un altro volo. Anche se la compagnia aerea è la stessa.",
        "In some airports there isn’t a “connection” path and you may need to redo the security checks and it may be required a visa": "In alcuni aeroporti non c'è un percorso per le \"coincidenze\" e potrebbe essere necessario rifare i controlli di sicurezza e potrebbe essere richiesto un visto.",
        "Select option hand luggage": "Selezionare la preferenza per il bagaglio a mano:",
        "Select option hold luggage": "Selezionare la preferenza per il bagaglio da stiva:",
        "I dont want this service": "Non desidero questo servizio",
        "Luggage Insurance Info": "Una sola assicurazione copre tutti i bagagli di un passeggero. In caso di ritardo di 96 ore del tuo bagaglio, riceverai un risarcimento di 1.000 euro.",
        "Booking code": "Codice prenotazione",
        "Select passenger": "Seleziona passeggero",
        "Payment was made": "Il pagamento di {amount} è stato completato tramite {payment}.",
        "Info not refundable": "Se desideri cancellare questo biglietto dopo l'acquisto, la compagnia aerea non rimborserà l'importo pagato.",
        "Info refundable": "Se desideri annullare il biglietto dopo l'acquisto, la compagnia aerea rimborserà l'importo rimanente dopo aver dedotto tutte le penali e le commissioni di servizio applicabili, se presenti.",
        "Transfer to airport": "Trasporto autonomo a {airport}",
        "If you are travelling hold luggage you need to collect your luggage and re-check it": "Se hai un bagaglio da stiva, dovrai ritirarlo e ripresentarlo al check-in",
        "Discount": "Sconto",
        "Complete purchasing": "Completa acquisto",
        "Accept terms and conditions": "Ho letto e accetto i termini e le condizioni, i termini dello Smart Bundle e il contratto di servizio",
        "Accept receive messages": "Desidero ricevere gratuitamente i buoni sconto, le offerte e le migliori proposte",
        "Tracking and delivery of luggage": "<b>Tracciamento e consegna del bagaglio perso</b> entro 96 ore",
        "Compensation of x in case": "<b>Risarcimento di {amount}</b> in caso di bagaglio perso per più di 96 ore",
        "No need of proofs": "<b>Non sono necessarie prove</b>",
        "All luggage includes": "<b>Tutti i bagagli sono inclusi</b>",
        "No insurance": "Nessuna assicurazione",
        "Flight cancellation message": "<b>Fino a 600€ di risarcimento</b> in caso di cancellazione del volo",
        "Flight delayed message": "<b>Fino a 600€ di risarcimento</b> in caso di ritardo volo maggiore di 6 ore",
        "Flight overbooking message": "<b>Fino a 600€ di risarcimento</b> in caso di overbooking del volo",
        "departure": "Andata",
        "return": "Ritorno",
        "children": "Bambini",
        "infants": "Neonati",
        "Included in the price": "Incluso nel prezzo",
        "Copy from Passenger": "Copia dati passeggero",
        "Total Price": "Prezzo Totale",
        "Step Passengers": "Dettagli Passeggeri",
        "Step Additional Services": "Servizi Aggiuntivi",
        "Step Summary and Payment": "Riepilogo e Pagamento",
        "Step Complete": "Completo",
        "Back to Search Results": "Torna ai risultati",
        "Step Search": "Ricerca Volo",
        "You need to collect your luggage and re-check it": "Devi recuperare il bagaglio e presentarti nuovamente al check-in",
        "Passenger": "Passeggero",
        "Booking Details": "Dettagli Prenotazione",
        "Select": "Seleziona",
        "Hand Luggage information": "Il bagaglio a mano può essere portato a bordo dell'aeroplano, può contenere liquidi non superiori a 100 ml per contenitore e ha un limite di dimensioni e peso.",
        "Hold Luggage information": "Il bagaglio viene trasportato in stiva, può contenere liquidi e deve essere consegnato al banco dell'aeroporto prima del volo.",
        "Remove Passenger": "Rimuovi Passeggero",
        "1 Hold Luggage": "1 Bagaglio in stiva",
        "X Hold Luggage": "{count} Bagagli in stiva",
        "per passenger": "per passeggero",
        "Add service": "Aggiungi servizio",
        "Remove service": "Rimuovi",
        "Disruption Protection Terms": "Servizio offerto da Trouble Flight, cliccando Aggiungi approvi i  <a href=\"{link}\" target=\"_blank\">termini e condizioni</a>",
        "Luggage Insurance Terms": "Servizio offerto da Blue Ribbon Bags, cliccando Aggiungi approvi i  <a href=\"{link}\" target=\"_blank\">termini e condizioni</a>",
        "Automatic Check-In On Time": "Check-in <b>sempre in tempo</b> senza penali",
        "Automatic Check-In In your EMail": "Carte d'Imbarco <b>inviata direttamente nella tua E-Mail</b>",
        "Automatic Check-In Terms": "Cliccando Aggiungi approvi i <a href=\"{link}\" target=\"_blank\">termini e condizioni</a>",
        "You can pay with": "Valute accettate:",
        "Your data are encrypted and safe": "Il tuo pagamento con carta di credito è sicuro con noi, utilizziamo tecnologie di sicurezza avanzate per garantire che i tuoi dati personali e informazioni sulla carta di credito siano protetti.",
        "Only X price": "solo {price}",
        "Summary": "Dettaglio",
        "Terms auto accepted": "Completando l'ordine dichiaro di aver letto e accettato i <a href=\"{link}\" target=\"_blank\">termini e condizioni, termini Smart Bundle e le condizioni di servizio</a>.",
        "Subtotal": "Subtotale",
        "Taxes and fees excluded": "Tasse escluse",
        "Service and Administration Taxes": "Tassa servizio",
        "Call us info": "Hai domande? Chiamaci",
        "Price per passenger": "{price} per passeggero",
        "Loading booking": "Stiamo confermando il prezzo con la compagnia aerea",
        "Small Hand Luggage section": "Piccolo bagaglio a mano",
        "Travel Insurance Info": "Assicurazione di viaggio",
        "Select your baggage": "Seleziona il tuo bagaglio",
        "Personal baggage": "Bagaglio personale",
        "Hand baggage": "Bagaglio a mano",
        "Included": "Incluso",
        "Small Hand Luggage information short": "Un piccolo bagaglio che può essere sistemato sotto il sedile di fronte alla tua sedia.",
        "Hand Luggage information short": "Un bagaglio a mano che può essere inserito nell'armadietto sopra il sedile.",
        "No Hand Luggage": "Nessun bagaglio a mano",
        "Includes also priority boarding for": "Include anche l'imbarco prioritario per",
        "Small Hand Luggage information": "Il bagaglio a mano di piccole dimensioni può essere portato a bordo, può contenere liquidi per un massimo di 100 ml, ha un limite di dimensioni e peso e deve essere posizionato obbligatoriamente sotto il sedile anteriore o sopra se non c'è spazio disponibile.",
        "1 Hand Luggage": "1 Bagaglio a mano",
        "X Hand Luggage": "{count} Bagagli a mano",
        "Hold baggage": "Bagaglio da stiva",
        "Hold Luggage information short": "Il bagaglio da stiva viene trasportato solo in stiva e verrà consegnato al banco dell'aeroporto prima del volo.",
        "No Hold Luggage": "Nessun bagaglio da stiva",
        "Automatic Check-In Short Description": "Ricevi la carta d'imbarco per il tuo volo nella tua e-mail",
        "Automatic Check-In Description": "Nella tua email, sempre puntuale",
        "Disruption Protection Short Description": "Fino a 600€ in caso di ritardo, cancellazione o overbooking",
        "Disruption Protection Description": "Nessuna commissione, rimborso del 100%.",
        "Track your lost luggage": "Rintraccia il tuo bagaglio smarrito",
        "Track your lost luggage Short Description": "Ritrova il tuo bagaglio smarrito o ricevi 1000€ di risarcimento",
        "Track your lost luggage Description": "Servizio offerto da Blue Ribbon Bags",
        "Payment Card": "Carta",
        "Payment Crypto": "Crypto",
        "Payment Wallet": "Portafoglio",
        "Complete purchasing on X": "Completa l'acquisto su {supplier}",
        "After submission, you will be redirected to supplier to complete next steps": "Dopo l'invio, sarai reindirizzato a {supplier} per completare le fasi successive.",
        "Thank you for your order!": "Grazie per il tuo ordine!",
        "The order confirmation has been sent to your email address": "La conferma dell'ordine è stata inviata al tuo indirizzo e-mail.",
        "Payment of AMOUNT accepted": "Pagamento di {amount} accettato",
        "Booking Status": "Stato della prenotazione",
        "Remove": "Rimuovi"
    },
    "booking-errors": {
        "account_closed": "Il conto bancario è stato congelato.",
        "account_frozen": "Il conto bancario ha restrizioni sul tipo o sul numero di pagamenti consentiti.",
        "bank_account_restricted": "Il conto bancario di destinazione non è più valido perché la filiale ha cambiato proprietà.",
        "bank_ownership_changed": "La banca non ha potuto elaborare il pagamento.",
        "could_not_process": "Le transazioni di addebito non sono approvate sul conto bancario.",
        "debit_not_authorized": "La banca ha rifiutato questo trasferimento. Contattare la banca prima di riprovare.",
        "card_declined": "Il conto Stripe non ha fondi sufficienti per coprire il pagamento.",
        "insufficient_funds": "Il numero di routing sembra corretto, ma il numero di conto non è valido.",
        "invalid_account_number": "La banca ci ha comunicato che il nome del titolare del conto bancario in archivio non è corretto.",
        "incorrect_account_holder_name": "La banca ci ha comunicato che l'indirizzo del titolare del conto bancario in archivio non è corretto.",
        "incorrect_account_holder_address": "La banca ha comunicato che il codice fiscale del titolare del conto corrente non è corretto.",
        "incorrect_account_holder_tax_id": "La banca non è stata in grado di elaborare questo pagamento a causa della sua valuta. Probabilmente perché il conto bancario non può accettare pagamenti in quella valuta.",
        "invalid_currency": "I dati del conto bancario in archivio sono probabilmente errati. Non è stato possibile trovare un conto bancario con questi dati.",
        "no_account": "La banca non supporta più i pagamenti su questa carta.",
        "unsupported_card": "Errore generico",
        "Generic error": "Pagamento fallito, riprovare",
        "payment_intent_authentication_failure": "La carta utilizzata non è più valida.",
        "expired_card": "Il CVC/CC2 della carta non è corretto.",
        "incorrect_cvc": "Errore durante il processo di pagamento",
        "processing_error": "Trova voli economici per {to} Aeroporto con Ninja Trip. Prenotare voli con Ninja Trip è semplice, veloce e soprattutto gratuito!"
    },
    "seo-flights-to": {
        "Find cheap flight": "Confronta voli economici per l'aeroporto di {to} semplicemente utilizzando la casella di ricerca in alto. I risultati della ricerca vi mostreranno la più ampia gamma di compagnie aeree e che offrono voli economici verso l'aeroporto di {to} in tutto il web, poi potete semplicemente prenotare i vostri voli per {to} direttamente inserendo i dati dei passeggeri, scegliendo il bagaglio a mano o da stiva, servizi aggiuntivi ed effettuando il pagamento. Il qualche ora riceverai il biglietto per il tuo volo per {to} direttamente nella tua casella di posta elettronica.",
        "Compare cheap flights": "Se le date di viaggio sono flessibili, Ninja Trip può mostrarvi i giorni più economici del mese per volare verso l'aeroporto di {to}. I nostri grafici e calendari ti mostrano il momento migliore per volare verso {to}. Tutti gli strumenti utili per poter davvero accaparrarti un volo economico.",
        "Bookmark cheap flights": "Se hai trovato un ottimo prezzo per il tuo volo per {to}, allora metteci tra i preferiti Ninja Trip, seguici su Facebook e Instagram e torna a cercare e prenotare su centinaia di compagnie aeree e migliaia di destinazioni in tutto il mondo.",
        "Find cheap flights 2": "Trova le migliori offerte di voli economici per {to} con Ninja Trip. Il prezzo minimo di un volo per Ninja Trip {market} è {min_price}, ma i prezzi dei voli dipendono dalla disponibilità di posti, dal giorno o dai giorni in cui si viaggia e dal momento della prenotazione.",
        "What airlines": "Quali compagnie aeree volano a {to} {market}?",
        "Number of airlines": "Numerose compagnie aeree offrono voli diretti e indiretti per {to} {market}, spesso tutti i giorni, tra cui {airlines}.",
        "City Airports": "Aeroporti di {to}",
        "City has one airport": "{to} ha un solo aeroporto: {aeroporti}.",
        "City has more airports": "{to} ha {conta} aeroporti: {aeroporti}.",
        "Title": "Voli per {to}",
        "Title it-it": "Voli per {to}",
        "Title en-gb": "Flights to {to}",
        "Title en-us": "Flights to {to}",
        "Title es-es": "Vuelos a {to}",
        "Title ro-ro": "Zboruri către {to}",
        "Title ro-md": "Zboruri către {to}",
        "Title ru-ru": "рейсы в {to}",
        "Title ru-md": "рейсы в {to}",
        "Prices for flights from market to destination": "Prezzi per i voli {market} a {to}",
        "Seo Title": "Voli economici per {to} Aeroporto ({to_code}) da {min_price} - NinjaTrip",
        "Seo Title No Price": "Voli economici per {to} Aeroporto ({to_code}) - NinjaTrip",
        "Seo Description": "Stai cercando voli per {to}? Confronta le compagnie aeree e i voli low cost per {to}. Cerca e risparmia ora con Ninja Trip.",
        "Seo Description No Price": "Stai cercando voli per {to}? Confronta le compagnie aeree e i voli low cost per {to}. Cerca e risparmia ora con Ninja Trip.",
        "Chart cheap flights": "Se le date di viaggio sono flessibili, Ninja Trip può mostrarti i giorni più economici del mese per volare a {to}. I nostri grafici ti mostrano il momento migliore per volare verso l'aeroporto di {to}, in modo che possiate davvero accaparrarvi un volo economico.",
        "Alt image index": "Voli per {to} - Foto {index}",
        "Related Airlines": "Compagnie aeree che volano a {to}"
    },
    "seo-flights-from": {"Flights from": "Voli da {from}"},
    "seo-flight": {"Flight from to": "Volo da {from} per {to}", "Flight to": "Volo per {to}"},
    "seo-aircompany": {
        "Company information": "Informazioni {aircompany}",
        "Average price": "Prezzo medio",
        "Most popular destination": "Destinazione più popolare",
        "Weekly flights": "Voli settimanali",
        "Country": "Paese",
        "Title": "Voli {aircompany} economici",
        "Title uk-en": "Zboruri {aircompany}",
        "Title ro-ro": "Zboruri {aircompany}",
        "Title md-ro": "Zboruri {aircompany}",
        "Title it-it": "Voli {aircompany}",
        "Title es-es": "Vuelos {aircompany}",
        "Title ru-ru": "полеты {aircompany}",
        "Title md-ru": "полеты {aircompany}",
        "Title from": "Voli {aircompany} economici da solo {prezzo}",
        "Seo Title": "Voli {aircompany} economici - Biglietti aerei | NinjaTrip",
        "Seo Title with Price": "Voli {aircompany} da solo {min_prezzo} - Biglietti aerei - NinjaTrip",
        "Alt image index": "Voli {aircompany} - Foto {index}",
        "Title en-gb": "{aircompany} Flights",
        "Title en-us": "{aircompany} Flights",
        "Title ro-md": "Zboruri {aircompany}",
        "Title ru-md": "полеты {aircompany}",
        "Seo Description": "Confronta i migliori voli con {aircompany}. Cerca e risparmia ora con Ninja Trip.",
        "Seo Description No Price": "Confronta i migliori voli con {aircompany}. Cerca e risparmia ora con Ninja Trip.",
        "Air Companies": "Compagnie aeree"
    },
    "share": {
        "Share this offer": "Condividi questa offerta",
        "Share flight": "Ehi, guarda questo volo!",
        "Copy": "Copia",
        "Share link offer": "Condividi il link dell'offerta",
        "Link copied": "Il link è stato copiato, puoi incollarlo ai tuoi amici"
    },
    "footer": {
        "International Websites": "I Nostri Siti",
        "Other destinations": "Altre destinazioni",
        "Follow us": "Seguici",
        "Ninja Trip": "Ninja Trip",
        "About Us": "Chi siamo",
        "Why Us": "Perché noi",
        "Media Room": "Sala press",
        "Work with us": "Lavora con noi",
        "Advertising": "Pubblicità",
        "Affiliation": "Affiliazione",
        "Copyright": "© {year} Tutti i diritti riservati. RO44531870 GTM Global Travel Management S.R.L. I servizi disponibili sul sito sono offerti da GTM Agency o dai suoi Partner.",
        "Iata Accredited Agency": "Agenzia accreditata Iata",
        "Airlines": "Compagnie aeree",
        "Destinations": "Destinazioni",
        "Routes": "Rotte",
        "Reservations": "Prenotazioni",
        "Support": "Supporto",
        "Follow us description": "Resta sintonizzato e accedi alle ultime offerte e sconti con:",
        'Any Flight': 'Any Flight'
    },
    "support": {
        "Support center": "Centro Assistenza",
        "Warning flights": "Avviso voli",
        "Incident is effecting flights in country": "L'incidente sta interessando i voli in {country}",
        "Incident is effecting flights with aircompany": "L'incidente sta interessando i voli con {aircompany}",
        "Incident is effecting flights at airport": "L'incidente sta interessando i voli nell'aeroporto {airport}",
        "Incident airline_system_failure": "Problemi tecnici in aeroporto",
        "Incident airport_staff_strike": "Sciopero del personale aeroportuale",
        "Incident atc_and_other_airline": "Sciopero dei controllori del traffico aereo",
        "Incident aircraft_incidents": "Incidente aereo",
        "Incident volcano_eruptions": "Eruzioni vulcaniche",
        "Incident thunderstorms": "Temporale",
        "Incident snowstorm": "Tempesta di neve",
        "Incident terrostic_alert": "Allarme terrorismo",
        "Incident war": "Conflitto bellico",
        "Incident bomb_alert": "Allarme bomba",
        "Incident political_unrest": "Disordini politici",
        "Incident floodings": "Alluvione",
        "Incident earthquakes": "Terremoti",
        "Incident airline_bankruptcy": "Fallimento di una compagnia aerea",
        "Incident airline_strike": "Sciopero del personale delle compagnie aeree",
        "Incident covid19": "Restrizioni di Covid 19",
        "Incident airport_incident": "Incidente aeroportuale",
        "Incident airport_blackout": "Blackout aeroportuale",
        "Incident disclamer": "Questo elenco non è da considerarsi completo, tutte le informazioni fornite non hanno valore legale e possono essere interpretate solo come un suggerimento.",
        "Contact us": "Contattateci",
        "Send request": "Invia richiesta",
        "Your request was sent": "La vostra richiesta è stata inviata. Risponderemo il prima possibile.",
        "Search on support center": "Cerca sul Centro Supporto",
        "Example Search": "Scrivi qualcosa come \"check-in\"",
        "Search": "Cerca",
        "Most common problems": "Problemi più comuni",
        "Contact Us": "Contattaci",
        "Search for X": "Ricerca \"{keyword}\"",
        "No articles found": "Nessun articolo trovato",
        "Not related to a reservation": "Non legato a una prenotazione",
        "No ID available": "ID non disponibile",
        "Booking Information": "Informazioni prenotazione",
        "Message start": "Ciao team Ninja Trip,\n\nGrazie",
        "Problem": "Problema",
        "Request": "Richiesta",
        "Send Request": "Invia Richiesta",
        "Thank you for your request": "Grazie per la tua richiesta!",
        "We will answer you via E-Mail on email as soon as possible": "Risponderemo il prima possibile via E-Mail all'indirizzo {email}.",
        "Create an account and use all the perks!": "Crea un account e sfrutta tutti i vantaggi!",
        "Fill passengers details once, use it every time": "Compila i dati dei passeggeri una volta sola.",
        "One click to fill and download the invoice": "Un solo clic per compilare e scaricare la fattura.",
        "Keep track of your trips and tickets": "Tieni traccia dei viaggi e dei biglietti.",
        "Automatic check-in or follow easy steps explained to print your boarding pass": "Effettua il check-in automatico o segui i semplici passaggi spiegati per stampare la tua carta d'imbarco.",
        "Support": "Assistenza",
        "Incident atc_and_other_airline-related_bodies": "Sciopero personale aeroportuale",
        "Cant find what you are looking for": "Non riesci a trovare quello che stai cercando?",
        "Get support from Ninja Trip": "Ottieni il supporto da Ninja Trip",
        "Contact us description": "Siamo qui per aiutarti. Contattaci via e-mail o tramite il modulo online."
    },
    "myaccount": {
        "No trips": "Ops, nessun viaggio è disponibile...",
        "Your trip is being confirmed": "Riceverai la prenotazione a breve",
        "My upcoming trips": "I miei prossimi viaggi",
        "Flight roundtrip from to": "Volo di andata e ritorno da {departure} a {destination}",
        "Flight oneway from to": "Volo di sola andata da {departure} a {destination}",
        "Checkin opens in date": "Il check-in apre il {data}",
        "Checkin is currently open": "Il check-in è attualmente aperto",
        "Check In Instructions": "Istruzioni per il check-in",
        "Check In Instructions details": "Per viaggiare è necessaria una carta d'imbarco. Di seguito troverete le istruzioni per scaricarle per tutte le compagnie del vostro viaggio.",
        "CheckIn warning": "In caso di più PNR è necessario ripetere la procedura una volta per ogni PNR.",
        "Check in will open x and close y": "Il check-in aprirà <b>{open}</b> e chiuderà <b>{close}</b> prima del volo.",
        "Start Check-In": "Iniziare il check-in",
        "Check-In": "Check-In",
        "Invoice": "Fattura",
        "Download invoice X": "Scarica fattura {series}{number}",
        "Sign up via E-Mail": "Iscriviti via e-mail",
        "Use another account": "Usa un altro account",
        "Sign up": "Iscriviti",
        "Passengers": "Passeggeri",
        "No Passengers First Row": "Ancora",
        "No Passengers Second Row": "nessun passeggero qui,",
        "No Passengers Third Row": "aggiungi il primo passeggero e risparmia tempo nelle tue prenotazioni",
        "Add Passenger": "Aggiungi Passeggero",
        "Edit": "Modifica",
        "Edit Profile": "Modifica Profilo",
        "Edit Password": "Modifica Password",
        "Details": "Dettagli",
        "All reservations": "Tutte le prenotazioni",
        "Future reservations": "Prenotazioni future",
        "Past reservations": "Prenotazioni passate",
        "See": "Visualizza",
        "My trips": "I Miei Viaggi",
        "Prev page": "« Precedenti",
        "Next page": "Successivi »",
        "Support": "Assistenza",
        "Product flight": "Volo"
    },
    "upload": {
        "Single file only": "Solo un file accettato.",
        "File uploaded correctly": "File caricato correttamente.",
        "X files uploaded correctly": "{n_files} file caricati correttamente."
    },
    "login": {
        "Login": "Accesso",
        "Logout": "Disconnessione",
        "My Account": "Mio Account",
        "Instruction Login Sign in": "Accedi a Ninja Trip o",
        "Instruction Login Create an account": "crea un nuovo account",
        "Continue with social": "Continua con {social}",
        "Hello name": "Ciao {name}",
        "Instruction Login Register": "Creiamo un nuovo account per te!",
        "Instruction Login Password": "Inserisci la password del tuo account Ninja Trip",
        "Go back": "o torna indietro",
        "Hello": "Ciao",
        "Accept Terms and Conditions": "Ho letto e accetto i Termini e le Condizioni e la Politica sulla Privacy.",
        "Offers": "Vogli9o ricevere le migliori offerte.",
        "Forgotten password": "Password dimenticata",
        "Sent link password": "Abbiamo inviato un'e-mail con il link per la reimpostazione della password all'indirizzo e-mail indicato.",
        "Welcome": "Benvenuto",
        "Instruction Login Reset Password": "Scegli una nuova password sicura",
        "The link is no longer valid": "Il link non è più valido. Probabilmente è passato troppo tempo ed è scaduto.",
        "E-Mail or password wrong": "Email o password errata",
        "Confirm E-Mail change": "Conferma la modifica dell'e-mail",
        "Profile edited correctly": "Profilo modificato correttamente",
        "Current Password": "Password attuale",
        "Password changed correctly": "La password è stata modificata correttamente",
        "Your session is expired": "La sessione è scaduta, effettuare nuovamente il login per continuare"
    },
    "validation": {
        "Password not safe enought": "La password non è sicura",
        "Accept terms error": "Non possiamo evadere l'ordine se non si accettano i termini e le condizioni",
        "Please use only latin letters": "Usa solo lettere senza accenti",
        "The credit card field is required": "Il numero della carta è richiesto",
        "The security code is required": "Il codice di sicurezza è richiesto",
        "The expiration data is required": "La data di scadenza è richiesta",
        "phone_invalid": "Il numero di telefono non è valido"
    },
    "seo-flights-route": {
        "Title": "Voli economici da {from} a {to}",
        "Seo Description": "Trova e prenota voli di sola andata o andata e ritorno da {from} a {to} alla tariffa migliore. Trova le migliori offerte e sconti. Ninja Trip ha il miglior team di assistenza nel settore dei viaggi.",
        "Chart Title": "Voli andata e ritorno da {from} a {to}",
        "Trip duration (days)": "Durata viaggio (giorni)",
        "How many airports in x": "Quanti aeroporti ci sono a {city}?",
        "Just airport of X with name": "A {city} c'è un solo aeroporto: {name}.",
        "Just airport of X no name": "È presente un solo aeroporto a {city}.",
        "There are X airports in X": "Ci sono {count} aeroporti a {city}: {airports}.",
        "How long does it take to fly from X to Y": "Quanto tempo ci vuole per un volo da {departure} a {destination}?",
        "The average flight time is hr and mins": "La durata media del volo è di {hour} ora e {minutes} minuti.",
        "The average flight time is hrs and mins": "La durata media del volo è di {hour} ore e {minutes} minuti.",
        "The average flight time is hrs": "La durata media del volo è di {hour} ore.",
        "The average flight time is hr": "La durata media del volo è di {hour} ora.",
        "The average flight time is mins": "La durata media del volo è di {minutes} minuti.",
        "Which aircompanies offer direct flights from X to Y": "Quali compagnie aeree offrono voli diretti da {departure} a {destination}?",
        "No direct flights": "Purtroppo non ci sono compagnie che offrono un volo diretto da {departure} a {destination}.",
        "Only one direct company": "C'è solo una compagnia aerea che offre un volo diretto da {departure} a {destination}: {aircompanies}.",
        "Many direct company": "{count} compagnie aeree offrono voli diretti da {departure} a {destination}: {aircompanies}.",
        "What is the cheapest time to buy a ticket for a flight from X to Y": "Qual è il momento più economico per acquistare un biglietto per un volo da {departure} a {destination}?",
        "What is the price for a flight from X to Y": "Qual è il prezzo del volo da {departure} a {destination}?",
        "The cheapest price is X": "Il prezzo più economico per un volo da {departure} a {destination} è {price}.",
        "The cheapest price both is X Y": "I prezzi più economici per un volo da {departure} a {destination} sono {price_oneway} per il volo di sola andata e {price_roundtrip} per il volo di andata e ritorno.",
        "The cheapest price roundtrip is X": "Il prezzo più economico di andata e ritorno per un volo da {departure} a {destination} è {price}.",
        "The cheapest price oneway is X": "Il prezzo più economico per un volo di sola andata da {departure} a {destination} è {price}.",
        "No indication price": "Al momento non abbiamo statistiche aggiornate, fai una ricerca sul nostro sito per avere i prezzi in tempo reale.",
        "Right now we have no indication about the best time to travel from X to Y": "Al momento non abbiamo indicazioni sul periodo migliore per viaggiare da {departure} a {destination}.",
        "Best moment to travel from X to Y is the month of Z": "In base alle nostre informazioni, il mese più economico per volare da {departure} a {destination} è {month}.",
        "Closest airport from X are": "In linea d'aria, gli aeroporti più vicini a {airport} sono {airports}.",
        "What airports are there near x": "Quali aeroporti ci sono vicino a {city}?",
        "Related airlines": "Linee aeree collegate",
        "Aircompany link": "Voli {aircompany} per {destination}",
        "Flight Departure Title": "Voli da {city}",
        "Flight Destination Title": "Voli per {city}",
        "Some prices of flights from X to Y": "Alcuni prezzi dei voli da {from} a {to}",
        "Title anchor": "Voli da {from} a {to}",
        "Title it-it": "Voli da {from} a {to}",
        "Title es-es": "Vuelos de {from} a {to}",
        "Title ro-ro": "Zboruri de la {from} către {to}",
        "Title md-ro": "Zboruri de la {from} către {to}",
        "Title md-ru": "Рейсы из {from} в {to}",
        "Reverse trip": "Viaggio inverso",
        "Seo Title": "Voli economici da {from} a {to} - {from_code} {to_code} - Biglietti aerei",
        "Title en-gb": "Flights from {from} to {to}",
        "Title en-us": "Flights from {from} to {to}",
        "Title ro-md": "Zboruri de la {from} la {to}",
        "Title ru-ru": "Рейсы {from} - {to}",
        "Title ru-md": "Рейсы {from} - {to}"
    },
    "checkin": {
        "Complete missing data for Check-In": "Completa i dati mancanti per il Check-In",
        "Instruction Fill Check-In": "Per completare il check-in sono necessarie alcune informazioni aggiuntive. Per evitare ritardi, ti preghiamo di inserire le informazioni mancanti il prima possibile, in modo da poter completare il vostro check-in e inviarlo immediatamente non appena sarà disponibile.",
        "Check-in closed": "Check-in chiuso",
        "Instruction Check-In Closed": "Siamo spiacenti ma il check-in per la tua prenotazione è già chiuso.",
        "passport": "Passaporto",
        "identity_card": "Carta d'identità",
        "Document type": "Tipo documento",
        "Example Document Number": "AX123456",
        "Document number": "Numero documento",
        "Date of emission": "Data di emissione",
        "Date of expiration": "Data di scadenza",
        "Legal info": "Cliccando sul pulsante \"Continua\" confermo sotto la mia responsabilità che tutti i dati inseriti sono corretti e che sono a conoscenza delle regole sui prodotti non ammessi a bordo.",
        "Check-In is already completed": "Abbiamo già ricevuto le informazioni per poter emettere il tuo check-in.",
        "Check-In Completed": "Grazie per aver completato tutte le informazioni mancanti per l'emissione del check-in.",
        "Check-In When sent": "Ti invieremo il check-in alcuni giorni prima della partenza, in base alle regole della compagnia aerea.",
        "Passport": "Passporto",
        "Identity Card": "Carta d'identità",
        "Instructions": "Inserisci il nome e il cognome esattamente come nel tuo passaporto/carta d'identità, altrimenti potresti essere rifiutato. Se hai un secondo nome, inseriscilo in \"Nome\"."
    },
    "partner": {
        "Service offered by Trouble Flight": "Servizio offerto da Trouble Flight",
        "This service is offered by a partner of Ninja Trip": "Questo servizio è offerto da un partner di Ninja Trip.",
        "To speed up the claim process, we can share your booking data with Trouble Flight": "Per accelerare l'apertura del reclamo, possiamo condividere i dati della tua prenotazione con Trouble Flight.",
        "This information includes": "Queste informazioni includono:",
        "Passenger names": "Nomi dei passeggeri",
        "Itinerary booked": "Itinerario prenotato",
        "Booking code": "Codice di prenotazione",
        "E-mail address and telephone number": "Indirizzo e-mail e numero di telefono",
        "Continue": "Continua",
        "Terms": "Cliccando su continua si autorizza Ninja Trip (GTM - Global Travel Management S.R.L.) a inviare i dati della prenotazione a Trouble Flight (Doorify Tech S.R.L.). Trouble Flight utilizzerà queste informazioni solo per accelerare la creazione di un reclamo. Dopo il clic, sarete reindirizzati al sito web di Trouble Flight dove potrete completare la vostra richiesta di risarcimento."
    },
    "seo-flights-to-country": {
        "Some prices of flights from X to Y": "Alcuni prezzi voli {from} per {to}",
        "Some prices same country to Y": "Alcuni prezzi voli per {to}",
        "How long does it take to fly X to Y": "Quanto tempo ci vuole per un volo {departure} a {destination}?",
        "The average flight time is hr and mins": "Considerando un volo da {airport_departure} a {airport_destination} la media del tempo di volo é di {hour} ora e {minutes} minuti.",
        "The average flight time is hrs and mins": "Considerando un volo da {airport_departure} a {airport_destination} la media del tempo di volo é di {hour} ore e {minutes} minuti.",
        "The average flight time is hrs": "Considerando un volo da {airport_departure} a {airport_destination} la media del tempo di volo é di {hour} ore.",
        "The average flight time is hr": "Considerando un volo da {airport_departure} a {airport_destination} la media del tempo di volo é di {hour} ora.",
        "The average flight time is mins": "Considerando un volo da {airport_departure} a {airport_destination} la media del tempo di volo é di {minutes} minuti.",
        "What is the price for a flight X to Y": "Qual è il prezzo del volo {departure} a {destination}?",
        "Cheapest price same outward roundtrip": "Il prezzo più economico per un volo {departure} a {destination} è, per un volo solo andata da {city_departure} a {city_destination} di {price_oneway} e {price_roundtrip} per un volo andata e ritorno.",
        "Cheapest price different outward roundtrip": "Il prezzo più economico per un volo {departure} a {destination} è, per un volo solo andata da {city_departure_oneway} a {city_destination_oneway} di {price_oneway} e {price_roundtrip} per un volo andata e ritorno da {city_departure_roundtrip} a {city_destination_roundtrip}.",
        "Cheapest price roundtrip": "Il prezzo più basso per un volo {departure} a {destination} è {price} per un volo di andata e ritorno da {city_departure} a {city_destination}.",
        "Cheapest price oneway": "Il prezzo più basso per un volo {departure} a {destination} è {price} per un volo di sola andata da {city_departure} a {city destination}.",
        "Which aircompanies flights X to Y": "Quali compagnie aeree volano {departure} a {destination}?",
        "Which aircompanies flights direct X to Y": "Quali compagnie aeree hanno voli diretti {departure} a {destination}?",
        "No airlines": "Al momento non abbiamo informazioni sulle compagnie aeree che operano da {departure} a {destination}.",
        "No airlines direct": "Al momento non abbiamo informazioni sulle compagnie aeree che operano voli diretti {departure} a {destination}.",
        "Only one company": "Una compagnia aerea opera {departure} verso {destination}: {aircompanies}.",
        "Only one company direct": "Una compagnia aerea effettua voli diretti {departure} verso {destination}: {aircompanies}.",
        "Many companies": "Le compagnie aeree che effettuano voli {destination} a {destination} sono {aircompanies}.",
        "Many companies direct": "Le compagnie aeree che effettuano voli diretti {destination} a {destination} sono {aircompanies}.",
        "Most popular airline": "Compagnia aerea più popolare",
        "Cheapest price": "Prezzo più basso",
        "Airports in X": "Aeroporti in {country}",
        "Airport link": "Voli per {destination}",
        "Title": "Voli per {destination}",
        "Subtitle": "Vola in {destination}"
    },
    "home": {"Popular Destinations": "Destinazioni Popolari", "Home": "Home"},
    "booking-status": {
        "Find Booking": "Trova la prenotazione",
        "Processing your booking": "Elaborazione della prenotazione...",
        "We are processing your booking request Please wait": "Stiamo elaborando la tua richiesta di prenotazione. Attendere prego",
        "Booking Code": "Prenotazione: {code}",
        "Booking completed": "Prenotazione completata",
        "Thank you for your booking": "Grazie per la tua prenotazione!",
        "Booking refused": "Prenotazione rifiutata",
        "We are sorry, but your booking cannot be confirmed": "Siamo spiacenti, ma la tua prenotazione non può essere confermata. Il tuo pagamento è stato rimborsato.",
        "Payment": "Pagamento",
        "Payment Method": "Metodo di pagamento",
        "Payment Amount": "Importo del pagamento"
    }
};